import { topics } from "@/mocks/freegua";

export default function Topics() {
  const big = topics.find((t) => t.big)!;
  const smalls = topics.filter((t) => !t.big);

  return (
    <section id="topics" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-bold text-primary-700">
              <i className="ri-archive-2-line" aria-hidden="true" />
              吃瓜专题
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              热门专题精选
            </h2>
            <p className="mt-3 max-w-xl text-base text-foreground-600">
              一整串事连在一起看才过瘾，专题把多则相关素材拼成完整的一条线。
            </p>
          </div>
        </div>

        <div className="mt-10 grid gap-5 lg:grid-cols-3">
          <article className="hover-lift group relative flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-100 lg:col-span-2 lg:flex-row">
            <div className="relative h-64 w-full overflow-hidden lg:h-auto lg:w-1/2">
              <img
                src={big.img}
                alt={big.title}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-background-100/40" />
            </div>
            <div className="flex flex-1 flex-col justify-center p-6 md:p-8">
              <span className="self-start whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
                {big.tag}
              </span>
              <h3 className="mt-4 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">{big.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{big.text}</p>
              <div className="mt-5 flex items-center justify-between">
                <span className="text-xs font-medium text-foreground-500">{big.time}</span>
                <a
                  href="#faq"
                  className="inline-flex items-center whitespace-nowrap text-sm font-bold text-primary-700 hover:text-primary-800"
                >
                  进去零元直接看
                  <i className="ri-arrow-right-line ml-1" aria-hidden="true" />
                </a>
              </div>
            </div>
          </article>

          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-1">
            {smalls.map((s) => (
              <a
                key={s.title}
                href="#follow"
                className="hover-lift group flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-100"
              >
                <div className="relative h-40 w-full overflow-hidden sm:h-32 lg:h-40">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-secondary-500 px-2.5 py-0.5 text-[11px] font-bold text-background-50">
                    {s.tag}
                  </span>
                </div>
                <div className="flex flex-1 items-center justify-between gap-3 p-4">
                  <h3 className="text-sm font-bold leading-snug text-foreground-900 group-hover:text-primary-700">{s.title}</h3>
                  <i className="ri-arrow-right-up-line shrink-0 text-accent-600" aria-hidden="true" />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}